<template>
    <b-modal
            id="winSeagameModal"
            :dialog-class="['modal-dialog-event', this.prizeKey === 'lucky' ? 'height-lucky' : '']"
            :content-class="['modal-worldcup modal-worldcup--win', dataRoll && dataRoll.length === 1 ? 'one' : 'ten']"
            hide-footer
            ok-only
            no-stacking
            centered
    >
        <div class="modal-wrapper">
            <div class="modal-top">
                <h3 class="modal-top__title">{{textFormatAnother}}</h3>
            </div>
            <div :class="['modal-content-point', this.prizeKey === 'lucky' ? 'mb-lucky' : '']">
                <div v-if="dataRoll && dataRoll.length === 1">
                    <h3 v-if="dataRoll">{{ handleDataPrizer(prizeKey, dataRoll[0].user_data, 1 ) }}</h3>
                    <d-img class="point" :src="winPrizesImage(prizeKey, 1)" alt="point"/>
                </div>
                <div v-else>
                    <div class="wrapper-point">
                        <div v-for="(item, index) in dataRoll" :key="index" class="item">
                            <p>{{isMobile ? '#' : 'Lượt quay' }} {{ index + 1 }}</p>
                            <div class="amount" :class="isMobile ? 'mb-item': ''">
                                <span> {{ handleDataPrizer(item.prizeKey, item.user_data, 10) }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="des-info-endgame" v-if="isEndGameWheel">
                Nạp và cược ngay để kiếm lượt chơi săn thưởng
            </div>
            <div :class="`des-info ${dataRoll && dataRoll.length === 10?'ten-roll': ''}`" v-else>
                <div class="title">QUAY NGAY- THỬ VẬN MAY</div>
                <div class="user-mount-wheel"><span>Bạn còn {{userTurn}} lượt chơi</span></div>
            </div>
            <div class="wrapper-button-modal text-center">
                <template v-if="isEndGameWheel">
                    <n-link :to="$device.isMobileOrTablet ? '/user/deposit?tab=index' : '/user/deposit'" class="button">
                        NẠP NGAY
                    </n-link>
                    <n-link to="/the-thao" class="button">
                        CƯỢC NGAY
                    </n-link>
                </template>
                <template v-else>
                    <button
                        @click="handleRollWheel(1)"
                        :disabled="currentUser && userTurn == 0"
                        :class="`button ${currentUser && userTurn == 0 ? 'btn-off': ''}`">QUAY 1 LƯỢT
                </button>
                    <button
                        @click="handleRollWheel(10)"
                        :disabled="currentUser && userTurn < 10"
                        :class="`button ${currentUser && userTurn < 10 ? 'btn-off': ''}`">QUAY 10 LƯỢT
            </button>
                </template>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: {
        dataRoll: {
            type: Array,
            default: null
        },
        prizeKey: {
            type: String,
            default: ''
        },
        isMobile: {
            type: Boolean,
            default: false
        },
        userTurn: {
            type: Number
        }
    },
    computed: {
        isEndGameWheel() {
            return this.userTurn === 0;
        },
        currentUser() {
            return this.$store.state.user;
        },
        textFormatAnother() {
            switch (this.prizeKey) {
                case '10k':
                case '100k':
                case '1trieu':
                case '2trieu':
                case '300k':
                case '50k':
                case '500k':
                case 'sieuhoantra':
                    return 'BẠN VỪA NHẬN ĐƯỢC';
                case 'goalthang':
                    return 'BẠN VỪA NHẬN TRẬN THẮNG';
                case 'hoa':
                    return 'BẠN VỪA NHẬN TRẬN HÒA';
                case 'lucky':
                    return 'CHÚC BẠN MAY MẮN LẦN SAU';
                case 'thua':
                    return 'BẠN VỪA NHẬN TRẬN THUA';
                default:
                    return 'BẠN ĐÃ HOÀN THÀNH \n 10 LƯỢT QUAY';
            }
        }
    },
    methods: {
        handleRollWheel(value) {
            if ((value === 1 && this.userTurn > 0) || (value === 10 && this.userTurn >= 10)) {
                this.$emit('emitDataRollWheel', value);
                this.$bvModal.hide('winSeagameModal');
            }
        },
        winPrizesImage(data, type) {
            switch (data) {
                case '10k':
                case '100k':
                case '1trieu':
                case '2trieu':
                case '300k':
                case '50k':
                case '500k':
                    return `/assets/img/event/worldcup/section-wheel/${type === 1 ? 'dolar' : 'coin'}.png`;
                case 'goalthang':
                    return '/assets/img/event/worldcup/section-wheel/point-3.png';
                case 'hoa':
                    return '/assets/img/event/worldcup/section-wheel/point-1.png';
                case 'lucky':
                    return '/assets/img/event/worldcup/section-wheel/point-lucky.png';
                case 'sieuhoantra':
                    return '/assets/img/event/worldcup/section-wheel/point-km.png';
                default:
                    return '/assets/img/event/worldcup/section-wheel/point-2.png';
            }
        },
        handleDataPrizer(prizeKey, data, type) {
            switch (prizeKey) {
                case '10k':
                case '100k':
                case '1trieu':
                case '2trieu':
                case '300k':
                case '50k':
                case '500k':
                    return `${data.toLocaleString()} ${type === 1 ? 'VND' : ''}`;
                case 'goalthang':
                case 'thua':
                case 'hoa':
                    return `${data !== 0 ? '+' : ''} ${data} ĐIỂM`;
                case 'lucky':
                    return 'LUCKY';
                case 'sieuhoantra':
                    return 'Hoàn trả 3%';
                default:
                    return '';
            }
        }
    }
};
</script>
